import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

export const CONFIRM_NOTES_MAX = 500

// words that start the confirm button of an action that loses or replaces data
const DESTRUCTIVE = /^(delete|remove|archive|close|replace|restore|reset)\b/i

export interface ConfirmDialogResult {
    button:string       // the text of the button chosen
    notes:string
}

// asks the user to confirm an action; closes with the button chosen, or nothing when cancelled or dismissed.
// Actions that can't be undone can ask for a word to be typed first
@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.html',
    styleUrls: ['./confirm-dialog.css'],
    standalone: false
})
export class ConfirmDialogComponent {
    notesControl = new FormControl('', {nonNullable:true, validators:Validators.maxLength(CONFIRM_NOTES_MAX)})
    confirmTextControl = new FormControl('', {nonNullable:true})
    CONFIRM_NOTES_MAX = CONFIRM_NOTES_MAX

    constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>, @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {}

    get needsConfirmText() {
        return !!this.data.confirmText?.length
    }

    // typed confirmation guards against clicking through; it only needs the word, not its exact case or spacing
    confirmDisabled():boolean {
        if (this.data.includeNotes && this.notesControl.invalid) return true
        if (!this.needsConfirmText) return false
        return this.confirmTextControl.value.trim().toLowerCase() !== this.data.confirmText.trim().toLowerCase()
    }

    isDestructive(button:string) {
        return this.needsConfirmText || DESTRUCTIVE.test(button || '')
    }

    onConfirm(button:string): void {
        if (this.confirmDisabled()) return
        this.dialogRef.close({button, notes: this.data.includeNotes ? this.notesControl.value.trim() : ""});
    }

    // pressing enter in the typed confirmation confirms once it matches
    onConfirmTextEnter(event:Event) {
        event.preventDefault()
        this.onConfirm(this.data.yesText)
    }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

    constructor(public title: string, public messages:string[], public confirmText?:string, public includeNotes:boolean=false, public yesText:string="Yes", public noText:string="No", public secondaryButton?:string) {
    }
}
